<template>
  <v-container
    v-if="part"
    class="bordered bg-white">
    <v-table
      class="border-table"
      density="compact">
      <thead>
        <tr>
          <th class="text-left font-weight-bold">
            {{
              t(
                "components.Calculations.Variants.ViewParts.ProductionCostsTab.Position"
              )
            }}
          </th>
          <th class="text-left font-weight-bold">
            {{
              t(
                "components.Calculations.Variants.ViewParts.ProductionCostsTab.Costs"
              )
            }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in fields"
          :key="item"
          :class="highlights.includes(item) ? 'font-weight-bold' : ''">
          <td>{{ t(`entities.part.fields.${item}`) }}</td>
          <td>
            <v-tooltip :text="part[item]">
              <template v-slot:activator="activator"
                ><span v-bind="activator.props">
                  {{
                    new Intl.NumberFormat("en-US", {
                      maximumFractionDigits: 2
                      // style: "currency",
                      // currency: 'EUR',
                    }).format(part[item])
                  }}</span
                >
              </template>
            </v-tooltip>
          </td>
        </tr>
      </tbody>
    </v-table>
  </v-container>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useTranslation } from "i18next-vue";
import { useSpaceStore } from "../../../../stores/spaceStore";

const spaceStore = useSpaceStore();

const { t } = useTranslation();
const part = ref(null);

const props = defineProps({
  nodeId: {
    type: String,
    required: true
  }
});

const fields = [
  "direct_material_costs_part",
  "material_overhead_costs_part",
  "interest_costs_on_material_stock_part",
  "material_scrap_costs_part",
  "material_costs_part",
  "work_system_costs_part",
  "labour_costs_part",
  "setup_costs_part",
  "tool_and_fixture_costs_part",
  "residual_manufacturing_overhead_costs_part",
  "interest_costs_of_circulating_stocks_part",
  "manufacturing_scrap_costs_part",
  "manufacturing_costs_part",
  "production_costs_part"
];

const highlights = [
  "material_costs_part",
  "manufacturing_costs_part",
  "production_costs_part"
];

onMounted(() => {
  part.value = spaceStore.calculationElements[props.nodeId];
  // part.value = {
  //   direct_material_costs_part: 0.6,
  //   material_overhead_costs_part: 1.14,
  //   interest_costs_on_material_stock_part: 12.4,
  //   material_scrap_costs_part: 3.6,
  //   material_costs_part: 11.3,
  //   work_system_costs_part: 0.45,
  //   labour_costs_part: 5.6,
  //   setup_costs_part: 12.6,
  //   tool_and_fixture_costs_part: 2.5,
  //   residual_manufacturing_overhead_costs_part: 1.34,
  //   interest_costs_of_circulating_stocks_part: 5.33123,
  //   manufacturing_scrap_costs_part: 9.8,
  //   manufacturing_costs_part: 13.5,
  //   production_costs_part: 11.5
  // };
});
</script>

<style scoped>
:deep() .v-data-table-header__content {
  font-weight: 700;
  font-size: smaller;
}

:deep() .v-table .v-table__wrapper > table > thead > tr > th:not(:last-child) {
  border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

:deep() .v-table .v-table__wrapper > table > tbody > tr > td:not(:last-child),
.v-table .v-table__wrapper > table > tbody > tr > th:not(:last-child) {
  border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}
</style>
